import { render } from "./BookmarkView.vue?vue&type=template&id=c53f8062"
import script from "./BookmarkView.vue?vue&type=script&lang=js"
export * from "./BookmarkView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__